module.exports = __webpack_public_path__ + "static/media/heater_off.788c5d24.png";